const POSTS_TO_LOAD = 20

export default POSTS_TO_LOAD
